import React from 'react'
import { useSelector } from 'react-redux'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import MyFormations from '../MyFormations/index'
import AdminFormations from '../AdminFormations/index'
import { Bg, MainLayout, ContentLayout } from './styledComponents'

const MyFormationsPage = () => {
  const isAdmin = useSelector((state) => state.toJS().global.isAdmin)

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        <ContentLayout>
          {isAdmin ? <AdminFormations /> : <MyFormations />}
        </ContentLayout>
      </MainLayout>
    </Bg>
  )
}

export default MyFormationsPage
